<!--
 * @Author: your name
 * @Date: 2021-09-30 10:28:39
 * @LastEditTime: 2023-04-27 16:04:29
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: In User Settings Edit
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/lincoln_national_day/index.vue
-->
<template>
  <linke/>
</template>
<script>
import banner from './components/banner.vue';
import appoint from './components/appoint.vue';
import videoComp from './components/video.vue';
import videoComp2 from './components/video2.vue';
import linke from '../lincoln2304_h/index.vue'
export default {
  components: {
    linke
  },
  data() {
    let list = [
      'https://source.qunarzz.com/site/images/wns/20230418-shijianchen-lin-1.jpg',
      'https://source.qunarzz.com/site/images/wns/20230418-shijianchen-lin-2.jpg',
      'https://source.qunarzz.com/site/images/wns/20230418-shijianchen-lin-3.jpg',
      'https://source.qunarzz.com/site/images/wns/20230418-shijianchen-lin-4.jpg',
      'https://source.qunarzz.com/site/images/wns/20230418-shijianchen-lin-5.jpg',
      'https://source.qunarzz.com/site/images/wns/20230418-shijianchen-lin-6.jpg',
      'https://source.qunarzz.com/site/images/wns/20230418-shijianchen-lin-7.jpg',
      'https://source.qunarzz.com/site/images/wns/20230418-shijianchen-lin-8.jpg',
      'https://source.qunarzz.com/site/images/wns/20230418-shijianchen-lin-9.jpg',
      'https://source.qunarzz.com/site/images/wns/20230418-shijianchen-lin-10.jpg',
    ];
    return {
      swiperList: list,
    };
  },
};
</script>
<style lang='less' scoped='true'>
.banner {
  height: 358px;
}
#main {
  background-color: #fff !important;
  height: 100vh;
  overflow-y: auto;
  font-size: 12px;
  color: #222;
}
.bgs {
  position: relative;
}
.lin-bg {
  height: 600px;
  position: relative;
  img {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
  }
}
.bg1 {
  background: url(https://source.qunarzz.com/site/images/wns/20220421-shijianchen-bg2.jpg)
    no-repeat;
  background-size: 100% 100%;
  height: 785px;
}
.img2 {
  height: 305px;
}
.jump1 {
  height: 96px;
}
.box2 {
  height: 211px;
  background-color: #fff;
}
.img3 {
  position: relative;
  height: 653px;
}
.link3 {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 0;
  height: 94px;
}
.box3 {
  height: 150px;
}
#bg {
  position: relative;
  left: 0;
  top: 0;
  padding-top: 640px;
}
.appint-2 {
  position: relative;
  top: 2605px;
  z-index: 2;
}
.bgList {
  font-size: 0;
  position: absolute;
  left: 0;
  top: 0;
}
.box {
  height: 200px;
}
img {
  display: block;
}
.appoint-1 {
  padding-bottom: 10px;
  background-size: 100% 100%;
  position: relative;
  box-sizing: border-box;
  font-size: 12px;
  padding-top: 10px;
}
.priceBox {
  position: relative;
  height: 1416px;
  img {
    position: absolute;
    left: 0;
    top: 0;
  }
  .text {
    position: absolute;
    width: 300px;
    text-align: center;
    font-size: 8px;
    color: #fff;
    bottom: 95px;
    z-index: 2;
    left: 50%;
    margin-left: -150px;
  }
}
.appoint-2 {
  background: url(https://source.qunarzz.com/site/images/wns/20220907-shijianchen-lincoln_14.jpg)
    no-repeat;
  background-size: 100% 100%;
  height: 588px;
  box-sizing: border-box;
  padding-top: 0;
  position: relative;
  font-size: 12px;
}
.swiperContainer {
  height: 643px;
  /deep/ .mint-swipe-indicator.is-active {
    background: #000;
    opacity: 1;
  }
}
.bottom {
  background: #adc4df;
}
.jumpTo {
  position: absolute;
  width: 178px;
  height: 24px;
  left: 99px;
  bottom: 35px;
}
.banner {
  position: relative;
}
.submit {
  position: absolute;
  width: 174px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 10px;
  height: 28px;
}
</style>